import { render, staticRenderFns } from "./IconSvgEmail.vue?vue&type=template&id=3ee5c077&scoped=true&"
import script from "./IconSvgEmail.vue?vue&type=script&lang=js&"
export * from "./IconSvgEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee5c077",
  null
  
)

export default component.exports